<!-- 七乐彩复式中奖计算 -->
<template>
    <div class="">
      <qlcfu :fu3="ssq"></qlcfu>
      <div class="clear"></div>
    </div>
  </template>
  
  <script>
  //import '../js/mpublic.js' //js文件引入，注意路径
  import qlcfu from "@/components/jin/fu.vue";
  //import api from '@/js/method'
  export default {
    name: "",
    components: {
      qlcfu,
    },
    data() {
      // 数据源
      return {
         ssq: [{"wanfa":'qlc',"xh":"复式个数","xl":"蓝球","zh":"命中个数(不含特码)","zl":"中特码",'xd':'胆码','xt':'拖码','zd':'中胆(不含特码)','zt':'中拖(不含特码)','ztl':'中特码','pic':require('@/assets/jpg/qlc.jpg')}],
      };
    },
    mounted() {},
    computed: {},
    methods: {
      // 函数体部分，js的主要逻辑控制
    
    },
    props: {},
  };
  </script>
  
  
  <style scoped>
  /* @import './swiper.css'; */
  
  .clear {
    clear: both;
  }
  </style>